// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
//ANTD
import InputNumber from 'antd/lib/input-number';

// EXPORTED COMPONENT
// ===================================
class SalesTaxInput extends React.Component {
  render() {
    const { onChange, value, rules, size, style } = this.props;

    return (
      <InputNumber
        // formatter={v => `${v}%`}
        // parser={v => v.replace('%', '')}
        onChange={onChange}
        value={value}
        size={size}
        style={style}
      />
    );
  }
}

SalesTaxInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  form: PropTypes.object,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number, PropTypes.array]),
  style: PropTypes.object,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  valueName: PropTypes.string,
  rules: PropTypes.array,
  size: PropTypes.string,
};

// Specifies the default values for props:
SalesTaxInput.defaultProps = {
  // label: 'Sales Tax %',
  // prefix: null,
  // style: {},
  size: 'large',
  // initialValue: 0,
  // message: 'Please input something!',
  // placeholder: '',
  // required: true,
  // valueName: 'salesTax',
  // rules: [],
};

export default SalesTaxInput;



// WEBPACK FOOTER //
// ./src/components/inputs/SalesTaxInput/index.js